import { ProductCode } from '@gb-ticket/shared-types';
import { type RouteObject } from 'react-router';

import { RequireAuthLayout, RequireProductLayout } from '@/platform/auth/require-permission';
import { PlatformShellLayout } from '@/platform/layouts/platform-shell';
import '@/products/onboarding/product-nav';
import { OnboardingLayout } from '@/products/onboarding/layouts/onboarding-layout';
import { ONBOARDING_ROOT } from '@/products/onboarding/onboarding-paths';
import { OnboardingCaseDetailPage } from '@/products/onboarding/pages/onboarding-case-detail-page';
import { OnboardingCasesPage } from '@/products/onboarding/pages/onboarding-cases-page';
import { OnboardingHomePage } from '@/products/onboarding/pages/onboarding-home-page';
import { OnboardingTemplateDetailPage } from '@/products/onboarding/pages/onboarding-template-detail-page';
import { OnboardingTemplatesPage } from '@/products/onboarding/pages/onboarding-templates-page';

/** Onboarding product (`/onboarding`) inside the Mitarbeiterportal chrome. */
export const onboardingRoute: RouteObject = {
  Component: RequireAuthLayout,
  children: [
    {
      Component: PlatformShellLayout,
      children: [
        {
          path: ONBOARDING_ROOT,
          element: <RequireProductLayout product={ProductCode.ONBOARDING} />,
          children: [
            {
              Component: OnboardingLayout,
              children: [
                { index: true, Component: OnboardingHomePage },
                { path: 'vorlagen', Component: OnboardingTemplatesPage },
                { path: 'vorlagen/:id', Component: OnboardingTemplateDetailPage },
                { path: 'vorgaenge', Component: OnboardingCasesPage },
                { path: 'vorgaenge/:id', Component: OnboardingCaseDetailPage },
              ],
            },
          ],
        },
      ],
    },
  ],
};
